export default "__VITE_ASSET__D_KY0KkY__"